import { createRouter, createWebHistory } from 'vue-router'
import KitabelerEserler from '../views/KitabelerEserler.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: KitabelerEserler
  },
  {
    path: '/kitabeler-ve-eserler',
    name: 'kitabeler-ve-eserler',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/KitabelerEserler.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
